import { createReducer } from '@reduxjs/toolkit';
import { openDrawer, closeDrawer, } from '@innovyze/stylovyze/lib/actions/drawer.actions';
export const initialState = '';
export default createReducer(initialState, builder => builder
    .addCase(openDrawer, (state, { payload }) => payload)
    .addCase(closeDrawer, state => ''));
